export default {
  DESKTOP_MIN_WIDTH: 801,
  MOBILE_WIDTH: 800,
}



// WEBPACK FOOTER //
// ./src/util/constants.js